<template>
    <div>
        <main class="content">
            <el-row :gutter="20">
                <el-col :span="4">
                    <el-card class="box-card" shadow="hover" style="width:100%" body-style="font-size:20px;background: linear-gradient(to right, #ff8ddb, #bb73df); color: #fff; text-align:center;">
                        <div><i class="el-icon-user" style="margin-right:5px"></i>{{userCount}} 人</div>
                        <div class="tip">注册用户数</div>
                    </el-card>
                </el-col>
                <el-col :span="4">
                    <el-card class="box-card" shadow="hover" style="width:100%" body-style="font-size:20px;background: linear-gradient(to right, #a7bfe8, #6190e8); color: #fff; text-align:center;">
                        <div><i class="el-icon-goods" style="margin-right:5px"></i>{{productCount}} 个</div>
                        <div class="tip">商品数量</div>
                    </el-card>
                </el-col>
                <el-col :span="4">
                    <el-card class="box-card" shadow="hover" style="width:100%" body-style="font-size:20px;background: linear-gradient(to right, #06beb6, #028ea1); color: #fff; text-align:center;">
                        <div><i class="el-icon-shopping-cart-full" style="margin-right:5px"></i>{{rfqCount}} 单</div>
                        <div class="tip">预询价单数</div>
                    </el-card>
                </el-col>
                <el-col :span="4">
                    <el-card class="box-card" shadow="hover" style="width:100%" body-style="font-size:20px;background: linear-gradient(to right, #028ea1, #06beb6); color: #fff; text-align:center;">
                        <div><i class="el-icon-document-checked" style="margin-right:5px"></i>{{dealRateCount}}%</div>
                        <div class="tip">成单率</div>
                    </el-card>
                </el-col>
                <el-col :span="4">
                    <el-card class="box-card" shadow="hover" style="width:100%" body-style="font-size:20px;background: linear-gradient(to right, #6190e8, #a7bfe8); color: #fff; text-align:center;">
                        <div><i class="el-icon-timer" style="margin-right:5px"></i>{{supplierResponseTime}} 天</div>
                        <div class="tip">供应商响应时效</div>
                    </el-card>
                </el-col>
                <el-col :span="4">
                    <el-card class="box-card" shadow="hover" style="width:100%" body-style="font-size:20px;background: linear-gradient(to right, #bb73df, #ff8ddb); color: #fff; text-align:center;">
                        <div><i class="el-icon-truck" style="margin-right:5px"></i>{{deliveryCycle}} 天</div>
                        <div class="tip">发货周期</div>
                    </el-card>
                </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-top:20px">
                <el-col :span="12">
                    <el-card class="box-card" shadow="hover" style="width: 100%">
                        <div slot="header" class="clearfix">
                            <span>最近7天注册用户数</span>
                        </div>
                        <div style="width:100%;height:300px;" ref="chartsRegister"></div>
                    </el-card>
                </el-col>
                <el-col :span="12">
                    <el-card class="box-card" style="width: 100%" shadow="hover">
                        <div slot="header" class="clearfix">
                            <span>最近7天日活</span>
                        </div>
                        <div style="width:100%;height:300px;" ref="chartsLogin"></div>
                    </el-card>
                </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-top:20px">
                <el-col :span="12">
                    <el-card class="box-card" shadow="hover" style="width: 100%">
                        <div slot="header" class="clearfix">
                            <span>最近7天预询价单数</span>
                        </div>
                        <div style="width:100%;height:300px;" ref="chartsAsk"></div>
                    </el-card>
                </el-col>
                <el-col :span="12">
                    <el-card class="box-card" shadow="hover" style="width: 100%">
                        <div slot="header" class="clearfix">
                            <span>最近7天成单数</span>
                        </div>
                        <div style="width:100%;height:300px;" ref="chartsOrder"></div>
                    </el-card>
                </el-col>
            </el-row>
        </main>
    </div>
</template>
<script>
    import * as echarts from 'echarts';
    export default {
        data() {
            return {
                userCount: '--',
                productCount: '--',
                rfqCount: '--',
                dealRateCount: '--',
                supplierResponseTime: '--',
                deliveryCycle: '--',
            }
        },

        created() {

        },
        mounted() {
            let that = this;
            this.$axios.get("/admin/statistics/userCount")
                .then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        that.userCount = resp.data;
                    }
                });
            this.$axios.get("/admin/statistics/productCount")
                .then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        that.productCount = resp.data;
                    }
                });
            this.$axios.get("/admin/statistics/rfqCount")
                .then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        that.rfqCount = resp.data;
                    }
                });
            this.$axios.get("/admin/statistics/dealRateCount")
                .then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        that.dealRateCount = resp.data;
                    }
                });
            this.$axios.get("/admin/statistics/supplierResponseTime")
                .then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        that.supplierResponseTime = resp.data;
                    }
                });
            this.$axios.get("/admin/statistics/deliveryCycle")
                .then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        that.deliveryCycle = resp.data;
                    }
                });
            this.$axios.post("/admin/statistics/register")
                .then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        that.chartsRegister = echarts.init(that.$refs.chartsRegister);
                        let optionRegister = {
                            tooltip: {
                                trigger: 'axis'
                            },
                            legend: {},
                            xAxis: [
                                {
                                    type: 'category',
                                    data: resp.data.map(it => it.key),
                                    axisPointer: {
                                        type: 'shadow'
                                    }
                                }
                            ],
                            yAxis: [
                                {
                                    type: 'value',
                                    alignTicks: true,
                                    axisLabel: {
                                        formatter: '{value} 人'
                                    },
                                    minInterval: 1,
                                },
                            ],
                            series: [
                                {
                                    type: 'line',
                                    tooltip: {
                                        valueFormatter: value => value + ' 人'
                                    },
                                    // prettier-ignore
                                    data: resp.data.map(it => it.value),
                                },
                            ]
                        };
                        // 4.传入数据
                        that.chartsRegister.setOption(optionRegister);
                    }
                });

            this.$axios.post("/admin/statistics/au")
                .then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        that.chartsLogin = echarts.init(that.$refs.chartsLogin);
                        let optionLogin = {
                            tooltip: {
                                trigger: 'axis'
                            },
                            legend: {},
                            xAxis: [
                                {
                                    type: 'category',
                                    data: resp.data.map(it => it.key),
                                    axisPointer: {
                                        type: 'shadow'
                                    }
                                }
                            ],
                            yAxis: [
                                {
                                    type: 'value',
                                    alignTicks: true,
                                    axisLabel: {
                                        formatter: '{value} 人'
                                    },
                                    minInterval: 1,
                                },
                            ],
                            series: [
                                {
                                    type: 'line',
                                    tooltip: {
                                        valueFormatter: value => value + ' 人'
                                    },
                                    // prettier-ignore
                                    data: resp.data.map(it => it.value),
                                },
                            ]
                        };
                        // 4.传入数据
                        that.chartsLogin.setOption(optionLogin);
                    }
                });

            this.$axios.post("/admin/statistics/ask")
                .then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        that.chartsAsk = echarts.init(that.$refs.chartsAsk);
                        let optionAsk = {
                            tooltip: {
                                trigger: 'axis'
                            },
                            legend: {},
                            xAxis: [
                                {
                                    type: 'category',
                                    data: resp.data.map(it => it.key),
                                    axisPointer: {
                                        type: 'shadow'
                                    }
                                }
                            ],
                            yAxis: [
                                {
                                    type: 'value',
                                    alignTicks: true,
                                    axisLabel: {
                                        formatter: '{value} 单'
                                    },
                                    minInterval: 1,
                                },
                            ],
                            series: [
                                {
                                    type: 'line',
                                    tooltip: {
                                        valueFormatter: value => value + ' 单'
                                    },
                                    // prettier-ignore
                                    data: resp.data.map(it => it.value),
                                },
                            ]
                        };
                        // 4.传入数据
                        that.chartsAsk.setOption(optionAsk);
                    }
                });

            this.$axios.post("/admin/statistics/order")
                .then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        that.chartsOrder = echarts.init(that.$refs.chartsOrder);
                        let option = {
                            tooltip: {
                                trigger: 'axis'
                            },
                            legend: {},
                            xAxis: [
                                {
                                    type: 'category',
                                    data: resp.data.map(it => it.key),
                                    axisPointer: {
                                        type: 'shadow'
                                    }
                                }
                            ],
                            yAxis: [
                                {
                                    type: 'value',
                                    alignTicks: true,
                                    axisLabel: {
                                        formatter: '{value} 单'
                                    },
                                    minInterval: 1,
                                },
                            ],
                            series: [
                                {
                                    type: 'line',
                                    tooltip: {
                                        valueFormatter: value => value + ' 单'
                                    },
                                    // prettier-ignore
                                    data: resp.data.map(it => it.value),
                                },
                            ]
                        };
                        // 4.传入数据
                        that.chartsOrder.setOption(option);
                    }
                });
        },
    }
</script>
<style scoped>
    .tip {
        color: #eee;
        font-size: 14px;
    }
</style>
